import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
// import {css} from "styled-components/macro"; //eslint-disable-line
import illustration from "images/login-illustration.svg";
import logo from "images/logo.svg";
import googleIconImageSrc from "images/google-icon.png";
import { ReactComponent as LoginIcon } from "feather-icons/dist/icons/log-in.svg";
import { useGoogleLogin } from '@react-oauth/google';
import { AuthApi, VisitorApi } from "utils/api";
//import { useAuth } from "utils/hooks/useAuth"; // From GOOGLE API
import { useAuth } from "hooks/useAuth"; // From MOCK API
import { useVisitors } from "hooks/useVisitors"; // From MOCK API
import { NotificationContainer, NotificationManager } from "react-notifications";
import { ROUTE_PATHS } from "utils/routes";
import logoLight from "images/logo-light.svg";

const Container = tw(ContainerBase)`min-h-screen bg-primary-900 text-white font-medium flex justify-center -m-8`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12`;
const LogoLink = tw.a``;
const LogoImage = tw.img`h-12 mx-auto`;
const MainContent = tw.div`mt-12 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;
const FormContainer = tw.div`w-full flex-1 mt-8`;
const TextUrl = tw.a`ml-2 font-bold text-sm text-blue-800`;
const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`
const Input = styled.input.attrs(props => ({ className: props.className }))`
  ${tw`px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-colors mb-4`}
  border-color: ${props => props.className && props.className.includes('border-red-500') ? '#ef4444 !important' : '#d1d5db'};
`;

const ButtonsContainer = tw.div`flex flex-col items-center`;
const SubmitButton = styled.button`
  ${tw`w-full max-w-xs font-semibold rounded-lg py-3 border text-gray-900 bg-gray-100 hocus:bg-gray-200 hocus:border-gray-400 flex items-center justify-center transition-all duration-300 text-sm mt-5 first:mt-0 hover:cursor-pointer`}
  .iconContainer {
    ${tw`bg-white p-2 rounded-full`}
  }
  .icon {
    ${tw`w-4`}
  }
  .text {
    ${tw`ml-4`}
  }
`;

const DividerTextContainer = tw.div`my-4 border-b text-center relative`;
const DividerText = tw.div`leading-none px-2 inline-block text-sm text-gray-600 tracking-wide font-medium bg-white transform -translate-y-1/2 absolute inset-x-0 top-1/2 bg-transparent`;
const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 bg-purple-100 text-center hidden lg:flex justify-center`;
const IllustrationImage = styled.div`
  ${props => `background-image: url("${props.imageSrc}");`}
  ${tw`m-12 xl:m-16 w-full max-w-sm bg-contain bg-center bg-no-repeat`}
`;

export default () => {
  const { login } = useAuth();
  const { fetchVisitors } = useVisitors();
  const navigate = useNavigate();

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [errors, setErrors] = React.useState({});

  const socialButtons = [
    {
      iconImageSrc: logoLight,
      text: "Iniciar Sesión con Email",
      url: ""
    }
  ];

  const getVisitors = async (id) => {
    await fetchVisitors(id).then((response) => {
      if (response.data.visitors.length > 0) {
        navigate(ROUTE_PATHS.HOME);
      }
    }).catch((error) => {
      console.log("Failed to get visitors: " + error);
    });
  };

  const getUser = async () => {
    let credentials = { email, password };
    await login(credentials).then(async (response) => {
      // Only fetch visitors for regular users, not admins
      if (response.data.user.role === 'user' && response.data.user.homeowner) {
        await getVisitors(response.data.user.homeowner.homeNumber);
      }
      
      // Role-based redirect
      if (response.data.user.role === 'admin') {
        navigate(ROUTE_PATHS.ADMINDASHBOARD, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }).catch((error) => {
      console.log("Failed to get user: " + error);
      if (error.message === "ERR_USER_NOTFOUND") {
        createNotification('error', 'El email no existe', error.message);
      }
      else {
        createNotification('error', 'Login failed', error.message);
      }
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!email) newErrors.email = "El correo es requerido.";
    else if (!/^\S+@\S+\.\S+$/.test(email)) newErrors.email = "Correo inválido.";
    if (!password) newErrors.password = "La contraseña es requerida.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    await getUser();
  };

  /*   const googleLogin = useGoogleLogin({
      onSuccess: (codeResponse) => {
        if (codeResponse) {
          AuthApi.getGoogleInfo(codeResponse.access_token).then(async (response) => {
            await getUser();
          }).catch((error) => {
            console.log("Failed to login: " + error);
          });
        }
      },
      onError: (error) => console.log('Login Failed:', error)
    }); */

  const createNotification = (type, message, title) => {
    switch (type) {
      case 'info':
        NotificationManager.info(message, title, 5000);
        break;
      case 'success':
        NotificationManager.success(message, title, 5000);
        break;
      case 'warning':
        NotificationManager.warning(message, title, 5000);
        break;
      case 'error':
        NotificationManager.error(message, title, 5000);
        break;
    }
  };

  return (
    <AnimationRevealPage>
      <Container>
        <Content>
          <MainContainer>
            <LogoLink href={"/"}>
              <LogoImage src={logo} />
            </LogoLink>
            <MainContent>
              <Heading>{"Inicia Sesión"}</Heading>
              <FormContainer>
                <DividerTextContainer>
                  <DividerText>Ingresa con el correo que registraste ante la administración</DividerText>
                </DividerTextContainer>
                <Form onSubmit={handleSubmit} noValidate>
                  <Input
                    type="email"
                    placeholder="correo electrónico"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                    className={errors.email ? "border-red-500" : ""}
                  />
                  {errors.email && <div className="text-red-500 text-xs mb-2">{errors.email}</div>}
                  <Input
                    type="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                    className={errors.password ? "border-red-500" : ""}
                  />
                  {errors.password && <div className="text-red-500 text-xs mb-2">{errors.password}</div>}
                  <ButtonsContainer>
                    {socialButtons.map((socialButton, index) => (
                      <SubmitButton key={index} type="submit" value="Submit">
                        <span className="iconContainer">
                          <img src={socialButton.iconImageSrc} className="icon" alt="" />
                        </span>
                        <span className="text">{socialButton.text}</span>
                      </SubmitButton>
                    ))}
                  </ButtonsContainer>
                </Form>

                <p className="mt-6 text-xs text-gray-600 text-center">
                  <TextUrl href={ROUTE_PATHS.CONTACTUS} className="border-b border-gray-500 border-dotted">
                    ¿Olvidaste tu contraseña?
                  </TextUrl>
                </p>
                <p className="mt-8 text-sm text-gray-600 text-center">
                  ¿No tienes cuenta?{" "}
                  <TextUrl href={ROUTE_PATHS.CONTACTUS}>
                    Contacta a tu administrador
                  </TextUrl>
                </p>
              </FormContainer>
            </MainContent>
          </MainContainer>
          <IllustrationContainer>
            <IllustrationImage imageSrc={illustration} />
          </IllustrationContainer>
        </Content>
        <NotificationContainer />
      </Container>
    </AnimationRevealPage>
  );
}